/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T16:23:43.388
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentPropertyDeliveryItemEditInit,
	getRentPropertyDeliveryItemView
} from '@api/rentmanage/RentPropertyDeliveryItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getRentPropertyDeliveryItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPropertyDeliveryItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentPropertyDeliveryItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPropertyDeliveryItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
